module.exports = __webpack_public_path__ + "img/sti-sc.b02d51fb.svg";